import React, { useContext, useEffect, useState } from "react";
import BoxComponent from "../../components/Box/BoxComponent";
import ImageLogoComponent from "../../components/Image/ImageLogoComponent";
import LogoIcon from "../../assets/images/logo_genioai.png";
import TypographyComponent from "../../components/Typography/ThypographyComponent";
import TextFieldComponent from "../../components/TextField/TextFieldComponent";
import { LoginDTO } from "../../provider/auth/AuthProps";
import ButtonComponent from "../../components/Button/ButtonComponent";
import FormComponent from "../../components/form/FormComponent";
import api from "../../api/api";
import { AuthContext } from "../../provider/auth/AuthContext";
import { useNavigate } from "react-router-dom";
import { EmpresaContext } from "../../provider/empresa/EmpresaContext";
import { useParams } from "react-router-dom";

const LoginPage = () => {
    const { login, logout } = useContext(AuthContext);
    const navigate = useNavigate();

    const [formLogin, setFormLogin] = useState<LoginDTO>({
        login: "",
        senha: ""
    });

    const [isTelefone, setIsTelefone] = useState<boolean>(false);

    const [errorMessage, setErrorMessage] = useState<string>("");

    const handleSubmit = async (e: any) => {
        e.preventDefault();
        const response = await login(formLogin);

        const path = window.location.pathname;
        const slug = path.split("/")[1];

        if (response !== null) {
            if (response) navigate(`/${slug}/dashboard/pedidos`);
        }
    }

    useEffect(() => {
        logout();
    }, []);

    const handleChangeLogin = (login: string) => {
        const isTelefone = login.length == 11 && !formLogin.login.includes("@");

        setIsTelefone(isTelefone);

        setFormLogin({
            ...formLogin,
            login: login
        });
    }

    return <BoxComponent component="section"
        sx={{
            display: "flex",
            width: "100%",
            height: "100dvh"
        }}
    >
        <BoxComponent component="section"
            sx={{
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                height: "100%",
                flex: 4,
                backgroundColor: "#44271D"
            }}
        >
            <ImageLogoComponent
                sx={{
                    margin: 1.85,
                    width: 245,
                    height: 245,
                    borderRadius: 2
                }}
                src={LogoIcon}
                alt="logo"
            />
        </BoxComponent>

        <FormComponent onSubmit={handleSubmit}
            sx={{
                display: "flex",
                flexDirection: "column",
                alignItems: "center",
                justifyContent: "center",
                height: "100%",
                flex: 1,
                gap: 2,
                px: 2
            }}
        >

            <TypographyComponent
                variant="h5"
                sx={{
                    fontFamily: '"Font 1", sans-serif',
                    fontWeight: 700,
                    fontSize: '24px',
                    lineHeight: '32px',
                    letterSpacing: '0%',
                    color: '#000000DE',
                    textAlign: 'center',
                    display: 'inline-flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                    verticalAlign: 'middle',
                    textTransform: "uppercase"
                }}
            >
                Acesse sua conta
            </TypographyComponent>

            <TextFieldComponent
                id="login"
                placeholder="Informe o telefone ou e-mail"
                variant="outlined"
                disableUnderline
                fullWidth
                value={formLogin.login}
                onInput={(e) => {
                    const target = e.target as HTMLInputElement;
                    handleChangeLogin(target.value);
                }}
                onChange={(e) => {
                    const target = e.target as HTMLInputElement;
                    handleChangeLogin(target.value);                    
                }}
                maskTelefone={isTelefone}
                required
            />

            <TextFieldComponent
                id="password"
                placeholder="Senha"
                variant="outlined"
                type="password"
                disableUnderline
                fullWidth
                value={formLogin.senha}
                onInput={(e) => {
                    const target = e.target as HTMLInputElement;
                    setFormLogin({
                        ...formLogin,
                        senha: target.value
                    });
                }}
                required
            />

            {errorMessage !== "" && <TypographyComponent
                variant="body2"
                sx={{
                    fontFamily: '"Font 1", sans-serif',
                    fontWeight: 700,
                    fontSize: '24px',
                    lineHeight: '32px',
                    letterSpacing: '0%',
                    color: '#000000DE',
                    textAlign: 'center',
                    display: 'inline-flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                    verticalAlign: 'middle',
                }}
            >
                {errorMessage}
            </TypographyComponent>}

            <ButtonComponent id="submit" type="submit"
                sx={{
                    backgroundColor: '#44271D',
                    display: 'inline-flex',
                    alignItems: 'center',
                    justifyContent: 'center',

                    // Tipografia do Botão
                    fontFamily: '"Font 1", sans-serif',
                    fontWeight: 600,
                    fontSize: '15px',
                    lineHeight: '26.25px',
                    letterSpacing: '0%',
                    color: '#FFFFFF',
                    textAlign: 'center',
                    verticalAlign: 'middle',

                    '&:hover': {
                        backgroundColor: '#331D15',
                    },
                    width: "100%",
                    textTransform: "uppercase"
                }}
            >
                Entrar
            </ButtonComponent>

            <ButtonComponent id="esqueci-senha" type="button" disabled
                sx={{
                    display: 'inline-flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                    borderColor: '#621B18', // Caso seja outlined, combina com a cor do texto

                    // Tipografia do Botão
                    fontFamily: '"Font 1", sans-serif',
                    fontWeight: 600,
                    fontSize: '16px',
                    lineHeight: '22.86px', // Convertido do token 22_86
                    letterSpacing: '0%',
                    color: '#621B18',
                    textAlign: 'center',
                    verticalAlign: 'middle',

                    '&:hover': {
                        borderColor: '#4A1412',
                        backgroundColor: 'rgba(98, 27, 24, 0.04)', // Feedback sutil de hover
                        color: '#4A1412'
                    },
                    width: "100%",
                    textTransform: "none"
                }}
            >
                Esqueci minha senha
            </ButtonComponent>

            <ButtonComponent id="ajuda" type="button" disabled
                sx={{
                    display: 'inline-flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                    borderColor: '#621B18', // Caso seja outlined, combina com a cor do texto

                    // Tipografia do Botão
                    fontFamily: '"Font 1", sans-serif',
                    fontWeight: 600,
                    fontSize: '12px',
                    lineHeight: '22.86px', // Convertido do token 22_86
                    letterSpacing: '0%',
                    color: '#621B18',
                    textAlign: 'center',
                    verticalAlign: 'middle',

                    '&:hover': {
                        borderColor: '#4A1412',
                        backgroundColor: 'rgba(98, 27, 24, 0.04)', // Feedback sutil de hover
                        color: '#4A1412'
                    },
                    width: "100%",
                    textTransform: "none"
                }}
            >
                Precisa de ajuda? Clique e fale com nosso suporte.
            </ButtonComponent>
        </FormComponent>



    </BoxComponent>
}

export default LoginPage;